import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IResOrder } from '@/types/plugins/envioFlex';

interface UseDetailsModalPluginsProps {
  orderId: string;
  clientId: string;
  isOpen: boolean;
}

const useDetailsModalPlugins = ({ orderId, clientId, isOpen }: UseDetailsModalPluginsProps) => {
  const [downloadModal, setDownloadModal] = useState<boolean>(false);
  const [orderData, setOrderData] = useState<IResOrder['data'][0] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const handleDownloadModal = () => {
    setDownloadModal(!downloadModal);
  };

  const downloadLabels = async ({
    pageSize,
    trackingIds,
  }: {
    pageSize: 'small' | 'letter' | 'zebra';
    trackingIds: string[];
  }) => {
    const http = initializeHttpProvider();
    try {
      const response = await http.orders.labels({
        pageSize,
        trackingIds,
      });
      if ('data' in response && !Array.isArray(response.data) && response.data.url) {
        window.open(response.data.url, '_blank');
        toast.success('Etiqueta descargada');
        setDownloadModal(false);
      } else {
        toast.error('Error al descargar la etiqueta');
      }
    } catch {
      toast.error('Ha ocurrido un error al intentar descargar la etiqueta');
    }
  };

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if (!orderId || !clientId) return;

      setLoading(true);
      setError(false);

      const http = initializeHttpProvider();
      try {
        const response = await http.envioFlex.order({ orderId, clientId });
        setOrderData((response as IResOrder).data[0]);
        setLoading(false);
      } catch {
        setError(true);
        setLoading(false);
      }
    };

    if (isOpen && orderId && clientId) {
      fetchOrderDetails();
    }
  }, [isOpen, orderId, clientId]);

  return { downloadModal, handleDownloadModal, orderData, loading, error, downloadLabels };
};

export default useDetailsModalPlugins;
